<template>
  <div class="page-outbox">
  	<!--banner部分-->
    <img class="banner-img" src="../../assets/banner-bg-r5.jpg"/>
    <!--logo-->
    <img class="logo-icon" src="../../assets/logo.png"/>
    <!--搜索框-->
    <form  action="javascript:void(0);" class="search-group inputcontent">
        <input class="search-input inputcontent" type="search" v-model="keyWord" @keydown.enter="searchSub"
               placeholder="请输入品名、货号、CAS号或关键字"><button class="search-btn" @click="searchSub"></button>
    </form>
  </div>
</template>

<script>
	export default {
    name: 'searchIndex',
    data () {
      return {
      	keyWord:''
      }
    },
    mounted(){
			if(this.$route.meta&&this.$route.meta.pageBelong){
				this.$store.commit('setPageBelong',this.$route.meta.pageBelong)
			}
			//获取焦点时移到页面可见区域
    	$('.inputcontent input').unbind('focus').bind('focus',function(e){
			 var dom=e.target;
				setTimeout(function(){
					dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
				}, 200);
				setTimeout(function(){
					dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
				}, 400);
				setTimeout(function(){
					dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
				}, 600);
			})
    },
		methods:{
			searchSub(){
				this.$router.push({path:'/GoodsList/'+this.keyWord});
			},
			ifWeChat() {
  			let ua = window.navigator.userAgent.toLowerCase();
  			return ua.match(/MicroMessenger/i) == 'micromessenger';
			}
		},
    components:{

    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
	.page-outbox{
		background-size: 100% auto;
		.banner-img{
			width: 100%;
		}
		.logo-icon{
		    padding: .3rem 0 .3rem;
				width: 1.5rem;
		    display: block;
		    margin: 0 auto;
		}
		.search-group{
				position: relative;
				display:block;
				width: 75%;
				min-width: 2.65rem;
				margin: 0 auto;
		    padding-bottom: .2rem;
		    text-align: center;
		    .search-input{
			    display: inline-block;
			    vertical-align:middle;
			    padding-right:.4rem;
			    box-sizing: border-box;
			    line-height: .4rem;
			    height: .4rem;
			    width: 100%;
			    border: 2px solid $mainColor;
			    font-size: .13rem;
			    color: #333;
			    text-indent: .05rem;
			    text-align: center;
			    -webkit-appearance: none;
    			border-radius: 0;
			    border-radius: .4rem;
			}
			.search-btn{
					position:absolute;
					top:0;
					right:0;
			    padding: 0 .08rem;
			    margin:0;
			    height: .4rem;
			    width: .36rem;
			    color: #fff;
			    border:none;
			    border-radius: 0 .4rem .4rem 0;
			    background: url(../../assets/search-icon-w.png) no-repeat center;
			    background-size: .2rem .2rem;
			    background-color: $mainColor;
				&:active{
				    background-color: #9f151e;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/searchIndex/searchIndex.vue